import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { IDriveContent } from 'src/@types/drive';
import { DriveRequests } from 'src/requests/drive';
import { QueryKey } from 'src/utils/react-query';

export const useDeleteContent = () => {
  const queryClient = useQueryClient();

  const { mutateAsync: deleteContent, isLoading: isDeleting } = useMutation(
    DriveRequests.deleteContent,
    {
      onSuccess(deletedContent) {
        queryClient.setQueryData<IDriveContent[]>(
          [QueryKey.DRIVE, deletedContent.parent || ''],
          (contents) =>
            contents?.filter(
              (content: IDriveContent) => content._id !== deletedContent._id,
            ),
        );
      },
    },
  );
  return {
    deleteContent,
    isDeleting,
  };
};
